import React from 'react';
import {useInstance} from 'react-ioc';
import {useNavigate} from 'react-router-dom';
import {useMutation} from '@apollo/client';
import {Button, DatePicker, Form, Input, Radio} from 'antd';
import dayjs from 'dayjs';
import {observer} from 'mobx-react-lite';

import {ENUM_USERSPERMISSIONSUSER_GENDER} from '../../__generated__/global-types';
import {Header} from '../../components/Header/Header';
import Layout from '../../components/Layout/Layout';
import {AVATAR, INDEX} from '../../config/routes';
import {Store} from '../../model/store/Store';

import {profileBase, profileBaseVariables} from './__generated__/profileBase';
import {MUTATION_PROFILE_BASE} from './auth';

interface IAnketForm {
    FIO: string;
    email: string;
    birthdate: dayjs.Dayjs;
    gender: string;
}

export const Profile = observer(() => {

    const [profileBase, {loading}] = useMutation<profileBase, profileBaseVariables>(MUTATION_PROFILE_BASE);
    const {auth} = useInstance(Store)
    const navigate = useNavigate()

    const onFinish = async (data: IAnketForm) => {
        await profileBase({
            variables: {
                data: {
                    FIO: data.FIO,
                    email: data.email,
                    birthdate: dayjs(data.birthdate).format('YYYY-MM-DD'),
                    gender: data.gender === 'male' ? ENUM_USERSPERMISSIONSUSER_GENDER.male : ENUM_USERSPERMISSIONSUSER_GENDER.female
                }
            },
            onCompleted: () => {
                auth.needUpdate()
                if (auth.data?.avatar) {
                    navigate(INDEX)
                } else {
                    navigate(AVATAR)
                }
            },
        })
    }

    return (
        <Layout header={<Header title={'Анкета'}/>} >
            <Form layout={'vertical'} onFinish={onFinish} validateTrigger={'onFinish'} initialValues={{
                FIO: auth.data?.FIO,
                birthdate: dayjs(auth.data?.birthdate),
                gender: auth.data?.gender,
                email: auth.data?.email,
            }}>
                <Form.Item name={'FIO'} label={'ФИО'} rules={[
                    {required: true, message: 'Заполните, пожалуйста'},
                ]}>
                    <Input placeholder={'Степанова София Тимуровна'}/>
                </Form.Item>
                <Form.Item name={'birthdate'} label={'Дата рождения'} rules={[
                    {required: true, message: 'Заполните, пожалуйста'},
                ]}>
                    <DatePicker style={{width:'100%'}} format={'DD.MM.YYYY'}/>
                </Form.Item>
                <Form.Item name={'gender'} label={'Пол'} rules={[
                    {required: true, message: 'Заполните, пожалуйста'},
                ]}>
                    <Radio.Group
                        options={[
                            {label: 'Мужской', value: 'male'},
                            {label: 'Женский', value: 'female'},
                        ]}
                        optionType="button"
                        buttonStyle="solid"
                    />
                </Form.Item>
                <Form.Item name={'email'} label={'Email'} rules={[
                    {required: true, message: 'Заполните, пожалуйста'},
                    {type: 'email', message: 'Не соответствует формату email'},
                ]}>
                    <Input placeholder={'name@example.com'}/>
                </Form.Item>
                <Form.Item>
                    <Button loading={loading} htmlType={'submit'} type={'primary'} block>Далее</Button>
                </Form.Item>
            </Form>
        </Layout>

    )
})